import { render, staticRenderFns } from "./Firm.vue?vue&type=template&id=7924097f&scoped=true"
import script from "./Firm.vue?vue&type=script&lang=js"
export * from "./Firm.vue?vue&type=script&lang=js"
import style0 from "./Firm.vue?vue&type=style&index=0&id=7924097f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7924097f",
  null
  
)

export default component.exports